import { render, staticRenderFns } from "./FailureDetailsTable.vue?vue&type=template&id=6791f938&"
import script from "./FailureDetailsTable.vue?vue&type=script&lang=js&"
export * from "./FailureDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./FailureDetailsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports